import { FC, useState, useMemo, } from 'react';
// 组件
import { ProTypography, ProTooltip } from '../../antd';
// 方法
import classnams from 'classnames';
// 常量
import { TABLE_COLUMN_EMPTY } from '../../constants/constant';

interface CopyColumnProps {
  text?: string;
  isBlock?: boolean;
}
/** 复制单元格内容 */
const CopyColumn: FC<CopyColumnProps> = props => {
  const { text, isBlock } = props;
  const [isMove, setIsMove] = useState<boolean>(false);
  const classes = classnams('ant-table-cell-ellipsis', {
    'padding-right-18': !isMove,
  });
  const divStyle = useMemo(() => {
    return isBlock ? undefined : { display: 'inline-flex' };
  }, [isBlock]);
  if (!text) return <div style={divStyle}>{TABLE_COLUMN_EMPTY}</div>;
  return (
    <ProTooltip placement="topLeft" title={text} mouseEnterDelay={1}>
      <div
        className="flex-center-start"
        style={divStyle}
        onMouseEnter={() => setIsMove(true)}
        onMouseLeave={() => setIsMove(false)}
      >
        <span className={classes}>{text}</span>
        {isMove && (
          <ProTypography.Paragraph
            className="margin-bottom-0"
            copyable={{
              text: text,
            }}
          />
        )}
      </div>
    </ProTooltip>
  );
};

CopyColumn.defaultProps = {
  isBlock: false,
};

export default CopyColumn;
